import client from '@/utils/httpClient';
import { useMutation, useQueryClient } from 'react-query';
import { OrgRoleKeys } from '../orgroles/orgrole.keys';
import { ConferenceUserAssignemtKeys } from './conferenceUserAssignment.keys';

async function deleteConferenceUserAssignment(id: string): Promise<void> {
  return client.delete<void>(`/conferenceuserassignments/${id}`).then((response) => response.data);
}

export function useDeleteConferenceUserAssignment() {
  const queryClient = useQueryClient();

  return useMutation((id: string) => deleteConferenceUserAssignment(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(ConferenceUserAssignemtKeys.list());
      queryClient.invalidateQueries(OrgRoleKeys.byUsers());
    },
  });
}
